import z from "zod";

const notificationsErrorTypeValues = ["PLACEHOLDER_ERROR", "PARTNER_MENTION_DELIVERY_FAILED"] as const;

const notificationsErrorTypeSchema = z.enum(notificationsErrorTypeValues);
const NotificationsErrorType = notificationsErrorTypeSchema.enum;
type NotificationsErrorType = z.infer<typeof notificationsErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type NotificationsErrors =
  | {
      errorType: typeof NotificationsErrorType.PLACEHOLDER_ERROR;
      data: Record<string, never>;
    }
  | {
      errorType: typeof NotificationsErrorType.PARTNER_MENTION_DELIVERY_FAILED;
      data: {
        messageId: string;
        runId: string;
        originalErrorName: string;
        originalErrorMessage: string;
      };
    };

export const notificationsErrorDetails: Record<NotificationsErrorType, ErrorDetails> = {
  [NotificationsErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "Notifications backend logic error",
  },
  [NotificationsErrorType.PARTNER_MENTION_DELIVERY_FAILED]: {
    sentryDescription: "Partner-mention email delivery subscriber exhausted retries",
  },
};
